import { convertToTwoDecimelNumber, formatDate, getCookie, simulateAsyncOperation, throttle } from "mmbclient/Common/CommonFunctions";
import { checkSession, getAllClients } from "mmbclient/Common/CommonService";
import { ACCOUNT_STATEMENT_REPORT, AD, All, API_PATH, APP_TYPE_COOKIE_NAME, EP, LOGIN_COOKIE_NAME, LOGIN_COOKIE_NAME_SPLITBY, LOGIN_SESSION_NAME, LOGIN_THROTTLE_TIME, PAGE_LOADING_TIME, US, USER_TYPE_COOKIE_NAME, WALLET } from "mmbclient/Common/CommonVariable";
import { RenderPagination } from "mmbclient/Components/RenderPagination";
import { useContext, useEffect, useState } from "react";
import * as XLSX from 'xlsx';

const AccountStatementController = (store) => {
    const wallet = useContext(WALLET);
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const [option, setOption] = useState('');
    const [client, setClient] = useState("All");
    const [clientOption, setClientOption] = useState([]);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);

    const [openingAmt, setOpeningAmt] = useState('');
    const [closingAmt, setClosingAmt] = useState('');
    const [totalCredit, setTotalCredit] = useState('');
    const [totalDebit, setTotalDebit] = useState('');

    const [startBal, setStartBal] = useState('');

    useEffect(() => {
        // Fetch data from server
        const fetchData = async () => {

            setLoading(true);
            try {
                if ((getCookie(USER_TYPE_COOKIE_NAME) === AD || getCookie(USER_TYPE_COOKIE_NAME) === EP)) {
                    await Promise.all([
                        loadAllClients(store),
                        simulateAsyncOperation(PAGE_LOADING_TIME),
                    ]);
                } else {
                    await Promise.all([
                        simulateAsyncOperation(PAGE_LOADING_TIME),
                    ]);
                }
            } catch (error) {
                console.log(error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    async function loadAllClients(store) {

        const response = await getAllClients(store);
        let lst_Client = [];
        lst_Client.push("All");
        if (response.length > 0) {
            let i;
            for (i of response) {
                lst_Client.push(i.client_name.toUpperCase() + " | " + i.client_code.toUpperCase());
            }
        }
        setClientOption(lst_Client);
        setClient(lst_Client[0]);
    }


    const loggerFunc = () => {
        checkSession(store);
  //      getClientBalance(wallet);
    }

    const betterLoggerFunction = throttle(loggerFunc, LOGIN_THROTTLE_TIME);

    const handleSearch = async () => {

        // Check if the end date is earlier than the start date
        if (endDate < startDate) {
            alert("End date cannot be earlier than start date.");
            return;
        }

        checkSession(store);
        if (!getCookie(LOGIN_SESSION_NAME)) {
            return;
        }

        setLoading(true);

        try {
            const cookie = getCookie(LOGIN_COOKIE_NAME);
            const cookieUserType = getCookie(APP_TYPE_COOKIE_NAME);
            const c = cookie.split(LOGIN_COOKIE_NAME_SPLITBY);

            const Data = "Data";
            if (c.length === 4) {
                let query = {};
                if ((getCookie(USER_TYPE_COOKIE_NAME) === AD || getCookie(USER_TYPE_COOKIE_NAME) === EP)) {
                    if (client === All) {
                        query = { "userKey": c[0], "userType": cookieUserType, "bean": Data, "clientCode": client, "brnCode": All, "fromDate": startDate.toISOString().slice(0, 10), "toDate": endDate.toISOString().slice(0, 10) };
                    } else {
                        const clientCode = client.split("|")[1].trim();
                        query = { "userKey": c[0], "userType": cookieUserType, "bean": Data, "clientCode": clientCode, "brnCode": All, "fromDate": startDate.toISOString().slice(0, 10), "toDate": endDate.toISOString().slice(0, 10) };
                    }
                } else if (getCookie(USER_TYPE_COOKIE_NAME) === US) {
                    query = { "userKey": c[0], "userType": cookieUserType, "bean": Data, "clientCode": c[1], "brnCode": All, "fromDate": startDate.toISOString().slice(0, 10), "toDate": endDate.toISOString().slice(0, 10) };
                }
                const requestOptions = {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: new URLSearchParams({
                        query:JSON.stringify(query)
                    })
                };
                const path = API_PATH + ACCOUNT_STATEMENT_REPORT + "getaccountstatement";
                // console.log(path);
                // console.log(JSON.stringify(query));
                const res = await fetch(path, requestOptions)
                const data = await res.json();
                const response = JSON.parse(data)[0].Data;
                if (response.length > 0 && response !== "Result Not Found") {

                    const opening = JSON.parse(data)[1].opening_amount;
                    if (opening > 0) {
                        // balTotal = opening;                        
                        setStartBal(opening);
                        setOpeningAmt(Math.abs(opening) + " Dr.");
                    } else if (opening < 0) {
                        // balTotal = opening;
                        setStartBal(opening);
                        setOpeningAmt(Math.abs(opening) + " Cr.");
                    } else {
                        // balTotal = opening;
                        setStartBal(opening);
                        setOpeningAmt(opening);
                    }

                    const closing = JSON.parse(data)[2].closing_amount;
                    if (closing > 0) {
                        setClosingAmt(Math.abs(closing) + " Dr.");
                    } else if (opening < 0) {
                        setClosingAmt(Math.abs(closing) + " Cr.");
                    } else {
                        setClosingAmt(closing);
                    }

                    const credit = JSON.parse(data)[3].total_credit_amount;
                    if (credit < 0) {
                        setTotalCredit(Math.abs(credit));
                    } else if (credit > 0) {
                        setTotalCredit(Math.abs(credit));
                    } else {
                        setTotalCredit(credit);
                    }

                    const debit = JSON.parse(data)[3].total_debit_amount;
                    if (debit < 0) {
                        setTotalDebit(Math.abs(debit));
                    } else if (debit > 0) {
                        setTotalDebit(Math.abs(debit));
                    } else {
                        setTotalDebit(debit);
                    }

                    setData(response);
                } else {
                    setData([]);
                    setOpeningAmt('');
                    setClosingAmt('');
                    setTotalCredit('');
                    setTotalDebit('');
                    setStartBal('');
                }
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
        setLoading(false);
    };

    const escapeCsvValue = (value) => {
        if (typeof value === 'string') {
            // Replace commas, newlines, and carriage returns with semicolons
            value = value.replace(/[,]/g, ';')    // Replace commas with semicolons
                .replace(/[\n]/g, ';')   // Replace newlines with semicolons
                .replace(/[\r]/g, ';');  // Replace carriage returns with semicolons
            // Optionally, escape double quotes by replacing them with two double quotes
            value = value.replace(/"/g, '""');
        }
        return value;
    };

    const exportToCSV = () => {
        const csvRows = [];

        let headers;
        if ((getCookie(USER_TYPE_COOKIE_NAME) === AD || getCookie(USER_TYPE_COOKIE_NAME) === EP)) {
            headers = [
                'SNo',
                'Client',
                'Entry No.',
                'Entry Type',
                'Entry Date',
                'Bank Detail',
                'Entry Mode',
                'Remarks',
                'Credit',
                'Debit',
                // 'Balance',
            ];
        } else {
            headers = [
                'SNo',
                'Entry No.',
                'Entry Type',
                'Entry Date',
                'Bank Detail',
                'Entry Mode',
                'Remarks',
                'Credit',
                'Debit',
                // 'Balance',
            ];
        }

        csvRows.push(headers.join(',')); // Add headers

        if ((getCookie(USER_TYPE_COOKIE_NAME) === AD || getCookie(USER_TYPE_COOKIE_NAME) === EP)) {
            data.forEach((item, index) => {                
                const values = [
                    escapeCsvValue(index + 1),
                    escapeCsvValue(item.client_name || ''),
                    escapeCsvValue(item.entry_no || ''),
                    escapeCsvValue(item.entry_type || ''),
                    escapeCsvValue(formatDate(item.entry_date) || ''),
                    escapeCsvValue(item.bank_detail || ''),
                    escapeCsvValue(item.entry_mode || ''),
                    escapeCsvValue(item.remarks || ''),
                    escapeCsvValue(item.credit_amount || ''),
                    escapeCsvValue(item.debit_amount || ''),
                    // escapeCsvValue(item.balance || ''),
                ];
                csvRows.push(values.join(',')); // Add data row
            });
        } else {
            data.forEach((item, index) => {
                const values = [
                    escapeCsvValue(index + 1),
                    escapeCsvValue(item.entry_no || ''),
                    escapeCsvValue(item.entry_type || ''),
                    escapeCsvValue(formatDate(item.entry_date) || ''),
                    escapeCsvValue(item.bank_detail || ''),
                    escapeCsvValue(item.entry_mode || ''),
                    escapeCsvValue(item.remarks || ''),
                    escapeCsvValue(item.credit_amount || ''),
                    escapeCsvValue(item.debit_amount || ''),
                    // escapeCsvValue(item.balance || ''),
                ];
                csvRows.push(values.join(',')); // Add data row
            });
        }

        const csvString = csvRows.join('\n');
        const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.setAttribute('href', url);
        link.setAttribute('download', 'data.csv');
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };


    const exportToExcel = () => {
        if (Array.isArray(data) && data.length === 0) {
            alert("No data found");
            return;
        }

        setLoading(true);
        let ws;
        if ((getCookie(USER_TYPE_COOKIE_NAME) === AD || getCookie(USER_TYPE_COOKIE_NAME) === EP)) {
            ws = XLSX.utils.json_to_sheet(data.map((item, index) => ({
                SNo: index + 1,
                Client: item.client_name || '',
                'Entry No.': item.entry_no || '',
                'Entry Type': item.entry_type || '',
                'Entry Date': formatDate(item.entry_date) || '',
                'Bank Detail': item.bank_detail || '',
                'Entry Mode': item.entry_mode || '',
                'Remarks': item.remarks || '',
                'Credit': item.credit_amount || '',
                'Debit': item.debit_amount || '',
                // 'Balance': item.balance || '',
            })));
        } else {
            ws = XLSX.utils.json_to_sheet(data.map((item, index) => ({
                SNo: index + 1,
                'Entry No.': item.entry_no || '',
                'Entry Type': item.entry_type || '',
                'Entry Date': formatDate(item.entry_date) || '',
                'Bank Detail': item.bank_detail || '',
                'Entry Mode': item.entry_mode || '',
                'Remarks': item.remarks || '',
                'Credit': item.credit_amount || '',
                'Debit': item.debit_amount || '',
                // 'Balance': item.balance || '',
            })));
        }

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Data');

        XLSX.writeFile(wb, 'Data.xlsx');
        setLoading(false);
    };


    const [currentPage, setCurrentPage] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const itemsPerPage = 5;

    // Filter data based on search term
    const filteredData = data.filter(item => {

        const lowerCaseSearchTerm = searchTerm.toLowerCase();

        return (
            String(item?.client_name)?.toLowerCase().includes(lowerCaseSearchTerm) ||
            String(item?.entry_no)?.toLowerCase().includes(lowerCaseSearchTerm) ||
            String(item?.entry_type)?.toLowerCase().includes(lowerCaseSearchTerm) ||
            String(item?.entry_date)?.toLowerCase().includes(lowerCaseSearchTerm) ||
            String(item?.bank_detail)?.toLowerCase().includes(lowerCaseSearchTerm) ||
            String(item?.entry_mode)?.toLowerCase().includes(lowerCaseSearchTerm) ||
            String(item?.remarks)?.toLowerCase().includes(lowerCaseSearchTerm) ||
            String(item?.credit_amount)?.toLowerCase().includes(lowerCaseSearchTerm) ||
            String(item?.debit_amount)?.toLowerCase().includes(lowerCaseSearchTerm)
        );
    }
    );

    // Calculate total pages
    const totalPages = Math.ceil(filteredData.length / itemsPerPage);

    // Get current items
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);


    function setPrecision(num) {
        // num = parseFloat(num);
        let index = num.toString().indexOf('.');
        if (index === -1) {
            return num;
        }
        return num.toPrecision(index + 2);
    }

    return { setPrecision, openingAmt, setOpeningAmt, closingAmt, setClosingAmt, totalCredit, setTotalCredit, totalDebit, setTotalDebit, startBal, setStartBal, searchTerm, setSearchTerm, setCurrentPage, currentItems, currentPage, totalPages, itemsPerPage, clientOption, client, setClient, loading, startDate, setStartDate, endDate, setEndDate, option, setOption, betterLoggerFunction, handleSearch, exportToCSV, exportToExcel, RenderPagination }
}

export default AccountStatementController;